export interface DocumentTitleParams {
    partner: string;
    from: string;
    to: string;
}

export const downloadFile = async (response: Response, documentTitle: DocumentTitleParams) => {
    const blob = await response.blob();
    const { partner, from, to } = documentTitle;
    const filename = `TIG-${partner.toUpperCase()}-${from}--${to}.xlsx`;
    const url = window.URL.createObjectURL(blob);
    const downLoadLink = document.createElement('a');
    downLoadLink.href = url;
    downLoadLink.download = filename;
    document.body.appendChild(downLoadLink);
    downLoadLink.click();
    await new Promise(resolve => setTimeout(resolve, 500));
    downLoadLink.remove();
    URL.revokeObjectURL(url);
};
